import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart3, Calculator, DollarSign, PieChart, Building2 } from 'lucide-react';

// Import all the modular components
import { TabNavigation } from './UIComponents';
import { useStockData } from './useStockData';
import StockHeader from './StockHeader';
import StockOverview from './StockOverview';
import StockStatistics from './StockStatistics';
import StockFinancials from './StockFinancials';
import StockRatios from './StockRatios';
import StockCompany from './StockCompany';

const InformationBar = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const { data, openCloseData, marketStatus } = useStockData();

  // Enhanced tab configuration with counts
  const tabs = [
    { id: 'overview', label: t('stocks.tabs.overview'), Icon: BarChart3 },
    { id: 'stats', label: t('stocks.tabs.statistics'), Icon: Calculator, count: 22 },
    { id: 'financials', label: t('stocks.tabs.financials'), Icon: DollarSign, count: 7 },
    { id: 'ratios', label: t('stocks.tabs.ratios'), Icon: PieChart, count: 11 },
    { id: 'company', label: t('stocks.tabs.company'), Icon: Building2, count: 6 },
  ];

  return (
    <div className="space-y-6">
      {/* Enhanced header with market status */}
      <StockHeader 
        data={data}
        marketStatus={marketStatus}
        openCloseData={openCloseData}
      />

      {/* Enhanced tab navigation */}
      <TabNavigation 
        tabs={tabs} 
        activeTab={activeTab} 
        onTabChange={setActiveTab} 
      />

      {/* Enhanced content area */}
      <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50 border border-gray-200 dark:from-gray-800/40 dark:via-gray-800/30 dark:to-gray-800/40 dark:border-gray-700/60 rounded-2xl p-6 backdrop-blur-sm">
        {activeTab === 'overview' && (
          <StockOverview data={data} openCloseData={openCloseData} />
        )}
        
        {activeTab === 'stats' && (
          <StockStatistics data={data} />
        )}
        
        {activeTab === 'financials' && (
          <StockFinancials data={data} />
        )}
        
        {activeTab === 'ratios' && (
          <StockRatios data={data} />
        )}
        
        {activeTab === 'company' && (
          <StockCompany data={data} />
        )}
      </div>
    </div>
  );
};

export default InformationBar;